const CourseCompletionOrderEnumCamelCase = {
  inOrder: 'inOrder',
  anyOrder: 'anyOrder'
};

export { CourseCompletionOrderEnumCamelCase };
export default CourseCompletionOrderEnumCamelCase;
